import { store } from "../../../../../stateManagement/store";
import { getUrlDirection } from "../../helpers";
import { fromLonLat, toLonLat, transformExtent } from "ol/proj";
import { setXML, setPanoramaFilters, setPanoramaCurrentHLookAngle, setPanoramaXMLIsLoading, setXMLChangeMarker, setCameraMarkerLongitude, setCameraMarkerLatitude, setShowCameras, setPanoramaWindowIsLoading, setPanoramaXMLIsRendering } from "../../../../../stateManagement/reducers/PanoramaSlice";
import { getItemWebStorage, setItemWebStorage } from "../../../../../features/webStorageSaver";
import { showToastMessage } from "../../../../../stateManagement/reducers";

// Получение координат по клику и их передача в виде запроса для панорамы
export async function getFrameOnMapPoint({ fetchFrameInPointQuery, argsLongitude, argsLatitude, isAfterLayerChange, argsYear, argsSeason, argsDirection }: any) {
    store.dispatch(setPanoramaXMLIsLoading(true))
    store.dispatch(setPanoramaWindowIsLoading(true))
    const mapPosition = getItemWebStorage('mapPosition')
    const currentConfig = getItemWebStorage('currentConfig')
    const panoramaState = store.getState().panorama
    const [defaultLongitude, defaultLatitude] = currentConfig.panoStart ?? []
    const cameraMarkerLongitude = panoramaState?.cameraMarkerLongitude || getItemWebStorage('cameraMarkerLongitude')
    const cameraMarkerLatitude = panoramaState?.cameraMarkerLatitude || getItemWebStorage('cameraMarkerLatitude')
    const zoom: any = mapPosition?.zoom ?? currentConfig?.mapDefaults?.zoom
    const searchTolerance = 1 / Math.pow(2, Math.floor(zoom / 1.4))
    const fetchLongitude = argsLongitude || cameraMarkerLongitude || defaultLongitude
    const fetchLatitude = argsLatitude || cameraMarkerLatitude || defaultLatitude
    const { panoramaYearFilter, panoramaSeasonFilter, panoramaDirectionFilter, xmlChangeMarker } = panoramaState
    const xmlResponse = await fetchFrameInPointQuery({
        longitude: fetchLongitude,
        latitude: fetchLatitude,
        tolerance: searchTolerance.toString(),
        year: argsYear || panoramaYearFilter || '0',
        season: argsSeason || panoramaSeasonFilter || '0',
        direction: argsDirection || getUrlDirection(panoramaDirectionFilter) || '0',
    });
    if (xmlResponse && xmlResponse.data) {
        const xml = xmlResponse?.data
        if (xml.includes('Error')) {
            store.dispatch(setPanoramaXMLIsLoading(false))
            store.dispatch(setPanoramaWindowIsLoading(false))
            store.dispatch(setPanoramaXMLIsRendering(false))
            let messageText = "Ошибка при загрузке панорамы"
            if (xml.includes('Video positions not found')) {
                messageText = 'В заданной позиции кадр не найден'
            } else if (xml.includes("Failed to open video file")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("property not found")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("Не удается найти указанный файл")) {
                messageText = 'Не удается найти указанный файл'
            }
            store.dispatch(showToastMessage({ messageText, messageType: "error", windowType: "map" }))
            if (isAfterLayerChange) {
                changeCameraMarkerPosition(fetchLongitude, fetchLatitude)
                store.dispatch(setXMLChangeMarker(!xmlChangeMarker))
                store.dispatch(setShowCameras(false))
                store.dispatch(setXML(null))
            }
            return false
        }
        else {
            store.dispatch(setXML(xml));
            store.dispatch(setShowCameras(xml.includes('<videoFrame>')))
            store.dispatch(setXMLChangeMarker(!xmlChangeMarker))
            store.dispatch(setPanoramaCurrentHLookAngle(0))
            store.dispatch(setPanoramaXMLIsLoading(false))
            return true;
        }
    }
    else {
        store.dispatch(showToastMessage({ messageText: 'Произошла ошибка во время запроса кадра', messageType: "error" }))
        store.dispatch(setPanoramaXMLIsLoading(false))
        store.dispatch(setPanoramaXMLIsRendering(false))
        store.dispatch(setPanoramaWindowIsLoading(false))
        return false
    }
}



export async function getPanoramaFiltersForBBOX(fetchPanoramaFilters: any, map?: any) {
    let zoom = map?.getView().getZoom()
    let extent = map.getView().calculateExtent()
    let boxLonLat = transformExtent(extent, "EPSG:3857", "EPSG:4326");
    if (boxLonLat[0] && boxLonLat[1] && boxLonLat[2] && boxLonLat[3]) {
        const filters = await fetchPanoramaFilters({ bbox: boxLonLat, zoom });
        filters.data && store.dispatch(setPanoramaFilters(filters.data));
    }
}

export async function getFrameOnMapPointAfterDragAndDrop({ fetchFrameInPointQuery, cameraMarkerLayer }: any) {
    const coordinates = cameraMarkerLayer?.getSource()?.getFeatures()[0]?.getGeometry().getCoordinates()
    const [newLongitude, newLatitude] = toLonLat(coordinates)
    const gotNewFrame = await getFrameOnMapPoint({ fetchFrameInPointQuery, argsLongitude: newLongitude, argsLatitude: newLatitude })
    if (!gotNewFrame) {
        const { cameraMarkerLongitude: prevLongitude, cameraMarkerLatitude: prevLatitude } = store.getState().panorama ?? {}
        const prevCoordinates = fromLonLat([prevLongitude, prevLatitude])
        cameraMarkerLayer?.getSource()?.getFeatures()[0]?.getGeometry().setCoordinates(prevCoordinates)
    }
}

export function changeCameraMarkerPosition(longitude: any, latitude: any) {
    store.dispatch(setCameraMarkerLongitude(longitude))
    store.dispatch(setCameraMarkerLatitude(latitude))
    setItemWebStorage('cameraMarkerLongitude', longitude)
    setItemWebStorage('cameraMarkerLatitude', latitude)
}

export function positionIsInMapView(position: any) {
    const extent = getItemWebStorage('mapPosition')?.extent
    if (extent) {
        let viewWidth = extent[2] - extent[0]
        let viewHeight = extent[3] - extent[1]
        let viewHBorder = viewWidth / 5
        let viewVBorder = viewHeight / 5

        var isInMapView = (extent[0] + viewHBorder < position[0]) &&
            (extent[2] - viewHBorder > position[0]) &&
            (extent[1] + viewVBorder < position[1]) &&
            (extent[3] - viewVBorder > position[1]);

        return isInMapView;
    }
    else return true
}